// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"e74e51d9","383":"6500a0b3","912":"5574473e","916":"dea50ad3"}[chunkId] + ".chunk.js";
};